/* eslint-disable indent */
/* eslint-disable no-undef */
export default {
	name: "driver-management",
	data() {
		return {
			drivers: [],
			driverVehicles: [],
			driverHeadings: [
				{
					text: "First Name",
					field: "firstName"
				},
				{
					text: "Last Name",
					field: "lastName"
				},
				{
					text: "Phone Number",
					field: "phoneNumber"
				},
				{
					text: "Is Active",
					field: "isActive"
				}
			],
			actionKeys:{
				edit: "edit",
				markAsActiveInactive: "markAsActiveInactive",
				viewVehicle: "viewVehicle"
			},
			pagingDetails:{
				pageNumber: 1,
				pageSize: 10,
				totalPages: 1
			},
			driverAddEditFormModal:{
				showModal: false,
				isSaving: false,
				modalId: "addEditDriverModal",
				heading: "Add Driver",
				driver:{
					driverId: null,
					firstName: {
						value: null,
						hasError: false,
						errorMessage: null
					},
					lastName: {
						value: null,
						hasError: false,
						errorMessage: null
					},
					phoneNumber: {
						value: null,
						hasError: false,
						errorMessage: null
					},
					employeeNumber: {
						value: null,
						hasError: false,
						errorMessage: null
					},
					isActive: true
				}
			},
			newAddOrUpdateConcluded: false,
			driverMarkAsActiveInactiveModal:{
				showModal: false,
				isSaving: false,
				modalId: "markAsActiveInactiveDriverModal",
				heading: "Mark Driver As Active/Inactive",
				isActive: null,
				driverId: null
			},
			driverViewVehicleModal:{
				showModal: false,
				modalId: "viewVehicleModal",
				heading: "View Vehicle",
				driverId: null
			},
			filterStateChanged: false,
			filter:{
				customerSearchQuery: null,
				activeOrInactiveItems: 1
			},
			activeIsActiveKey:{
				active: 1,
				inactive: 0
			},
			pageNumber: 1,
			pageSize: 100,
			loading: false,
			selectedHeartbeatStatusCodeId: null
		};
	},
	methods: {
		getDrivers(){
			this.loading = true;
			let request = {
				searchQuery: this.filter.customerSearchQuery,
				isActive: castingUtility.toBoolean(this.filter.activeOrInactiveItems),
			};
			systemService.getAllDrivers(request).then(
				successResponse => {
					let isSuccess = apiResponseHandlerHelepr.displayResponseMessageBasedOnApiResponseStatus(successResponse.data.responseStatus, successResponse.data.httpStatusCode, successResponse.data.message);
					if(isSuccess){
						this.drivers = successResponse.data.result;
						for(let i = 0; i < this.drivers.length; i++){
							this.drivers[i].actions = [
								{
									name: "Edit",
									key: this.actionKeys.edit,
									elementId: "btnLogisticsDriverEditDriver"
								},
								{
									name: this.drivers[i].isActive ? "Mark As Inactive" : "Mark As Active",
									key: this.actionKeys.markAsActiveInactive,
									elementId: "btnLogisticsDriverMarkAsActiveInactive"
								},
								{
									name: "View Vehicle",
									key: this.actionKeys.viewVehicle,
									elementId: "btnLogisticsDriverViewVehicle"
								}
							];
						}
						this.drivers = dataTableHelper.castFieldValues(this.drivers);
						this.filterStateChanged = false;
						this.newAddOrUpdateConcluded = false;
						permissionsHelper.setControlsBasedOnPermissions();
					}
					this.loading = false;
				},
				errorResponse => {
					console.log("error", errorResponse);
					this.loading = false;
					apiResponseHandlerHelepr.displaySessionExpiredMessage(errorResponse.response.status);
				}
			);
		},
		onFilterSearchClicked(){
			console.log("Search filter clicked");
			this.getDrivers();
		},
		onActiveInactiveFilterSelected(activeOrInactiveKey){
			this.filter.activeOrInactiveItems = activeOrInactiveKey;
			this.filterStateChanged = true;
			console.log("filter", this.filter);
		},
		onAddDriverClick(){
			this.driverAddEditFormModal.showModal = true;
		},
		onDriverActionClicked(actionAndData){
			console.log("actionAndData", actionAndData);
			switch(actionAndData.action){
				case this.actionKeys.edit:
					this.driverAddEditFormModal.showModal = true;
					this.driverAddEditFormModal.heading = "Edit Driver - " + actionAndData.data.firstName + " " + actionAndData.data.lastName;
					this.driverAddEditFormModal.driver.driverId = actionAndData.data.driverId;
					this.driverAddEditFormModal.driver.firstName.value = actionAndData.data.firstName;
					this.driverAddEditFormModal.driver.lastName.value = actionAndData.data.lastName;
					this.driverAddEditFormModal.driver.phoneNumber.value = actionAndData.data.phoneNumber;
					this.driverAddEditFormModal.driver.employeeNumber.value = actionAndData.data.employeeNumber;
					this.driverAddEditFormModal.driver.isActive = castingUtility.toBoolean(actionAndData.data.isActive);
					break;
				case this.actionKeys.markAsActiveInactive:
					this.driverMarkAsActiveInactiveModal.showModal = true;
					this.driverMarkAsActiveInactiveModal.isActive = castingUtility.toBoolean(actionAndData.data.isActive);
					this.driverMarkAsActiveInactiveModal.heading = "Mark Driver As " + (this.driverMarkAsActiveInactiveModal.isActive ? "Inactive" : "Active") + " - " + actionAndData.data.firstName + " " + actionAndData.data.lastName;
					this.driverMarkAsActiveInactiveModal.driverId = actionAndData.data.driverId;
					break;
				case this.actionKeys.viewVehicle:
					this.driverViewVehicleModal.showModal = true;
					this.driverViewVehicleModal.heading = "View Vehicle - " + actionAndData.data.firstName + " " + actionAndData.data.lastName;
					this.driverViewVehicleModal.driverId = actionAndData.data.driverId;
					break;
			}
		},
		
		onMarkDriverActiveInactiveSelected(isActive){
			this.driverMarkAsActiveInactiveModal.isActive = isActive;
			console.log("driverMarkAsActiveInactiveModal.isActive", this.driverMarkAsActiveInactiveModal.isActive);
		},
		onMarkAsActiveInactiveSaveClick(markAsActive){
			this.driverMarkAsActiveInactiveModal.isSaving = true;
			let request = {
				driverId: this.driverMarkAsActiveInactiveModal.driverId,
				isActive: markAsActive
			};
			systemService.markDriverAsActiveOrInactive(request).then(
				successResponse => {
					let isSuccess = apiResponseHandlerHelepr.displayResponseMessageBasedOnApiResponseStatus(successResponse.data.responseStatus, successResponse.data.httpStatusCode, successResponse.data.message);
					if(isSuccess){
						this.getDrivers();
						this.driverMarkAsActiveInactiveModal.showModal = false;
						this.driverMarkAsActiveInactiveModal.isActive = true;
						this.driverMarkAsActiveInactiveModal.driverId = null;
					}
					this.driverMarkAsActiveInactiveModal.isSaving = false;
				},
				errorResponse => {
					console.log("error", errorResponse);
					this.driverMarkAsActiveInactiveModal.isSaving = false;
					apiResponseHandlerHelepr.displaySessionExpiredMessage(errorResponse.response.status);
				}
			);
		},
		onAddOrEditDriverModalCloseClick(){
			this.driverAddEditFormModal.showModal = false;
			this.clearDriverModel();
		},
		onAddOrEditDriverSaveClick(){
			this.driverAddEditFormModal.isSaving = true;
			let request = {
				driverId: this.driverAddEditFormModal.driver.driverId,
				firstName: this.driverAddEditFormModal.driver.firstName.value,
				lastName: this.driverAddEditFormModal.driver.lastName.value,
				phoneNumber: this.driverAddEditFormModal.driver.phoneNumber.value,
				employeeNumber: this.driverAddEditFormModal.driver.employeeNumber.value,
				isActive: this.driverAddEditFormModal.driver.isActive
			};
			systemService.addOrUpdateDriver(request).then(
				successResponse => {
					let isSuccess = apiResponseHandlerHelepr.displayResponseMessageBasedOnApiResponseStatus(successResponse.data.responseStatus, successResponse.data.httpStatusCode, successResponse.data.message);
					if(isSuccess){
						if(successResponse.data.driverValidationResponse.valuesAreValid){
							this.getDrivers();
							this.driverAddEditFormModal.showModal = false;
							this.clearDriverModel();
						}
						else{
							this.driverAddEditFormModal.driver.firstName.hasError = successResponse.data.driverValidationResponse.firstNameValidationResponse.hasError;
							this.driverAddEditFormModal.driver.firstName.errorMessage = successResponse.data.driverValidationResponse.firstNameValidationResponse.message;

							this.driverAddEditFormModal.driver.lastName.hasError = successResponse.data.driverValidationResponse.lastNameValidationResponse.hasError;
							this.driverAddEditFormModal.driver.lastName.errorMessage = successResponse.data.driverValidationResponse.lastNameValidationResponse.message;

							this.driverAddEditFormModal.driver.employeeNumber.hasError = successResponse.data.driverValidationResponse.employeeNumberValidationResponse.hasError;
							this.driverAddEditFormModal.driver.employeeNumber.errorMessage = successResponse.data.driverValidationResponse.employeeNumberValidationResponse.message;

							this.driverAddEditFormModal.driver.phoneNumber.hasError = successResponse.data.driverValidationResponse.phoneNumberValidationResponse.hasError;
							this.driverAddEditFormModal.driver.phoneNumber.errorMessage = successResponse.data.driverValidationResponse.phoneNumberValidationResponse.message;
						}
					}
					this.driverAddEditFormModal.isSaving = false;
				},
				errorResponse => {
					console.log("error", errorResponse);
					this.driverAddEditFormModal.isSaving = false;
					apiResponseHandlerHelepr.displaySessionExpiredMessage(errorResponse.response.status);
				}
			);
		},
		onDriverVehicleModalOkClicked(){
			this.driverViewVehicleModal.showModal = false;
			this.driverViewVehicleModal.driverId = null;
		},
		clearDriverModel(){
			this.driverAddEditFormModal.driver = {
				driverId: null,
				firstName: {
					value: null,
					hasError: false,
					errorMessage: null
				},
				lastName: {
					value: null,
					hasError: false,
					errorMessage: null
				},
				phoneNumber: {
					value: null,
					hasError: false,
					errorMessage: null
				},
				employeeNumber: {
					value: null,
					hasError: false,
					errorMessage: null
				},
				isActive: true
			};
		},
		setBreadcrumbs() {
			storeState.setPageTitleAction("Driver Management");
			var breadcrumbs = [];
			var breadcrumbLogistics = {
				url: null,
				displayText: "Logistics"
			};
			var driverManagementBreadcrumb = {
				url: this.$route.path,
				displayText: "Driver Management"
			};
			breadcrumbs.push(breadcrumbLogistics);
			breadcrumbs.push(driverManagementBreadcrumb);
			breadcrumbsStoreState.setBreadcrumbs(breadcrumbs);
		}
	},
	mounted: function () {
		this.setBreadcrumbs();
		this.getDrivers();
	}
};